<template>
    <div class="__l">
        <h1 class="title">Knowledgebase</h1>
        <div class="actions right text-right">
            <button class="btn-tertiary" type="button" @click="navigateToCategories">Manage Categories</button>
            <button class="btn-primary" type="button" @click="createArticle">Create Article</button>
        </div>
        <input type="text" v-model="search" class="form-field py-4 px-6" ref="searchbar"
               placeholder="Search for Article" @keyup.enter="handleSearch">

        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="40%">Title</div>
                <div class="results-head" data-width="30%">Category</div>
                <div class="results-head" data-width="20%">Container</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectedArticle(result)">
                    <div class="results-cell" data-width="10%">{{ result.kb_id }}</div>
                    <div class="results-cell truncate" data-width="40%">{{ result.kb_title }}</div>
                    <div class="results-cell truncate" data-width="30%">{{
                            result.category ? result.category.kcat_title : ''
                        }}
                    </div>
                    <div class="results-cell truncate" data-width="20%">
                        {{ result.container ? result.container.name : '(Default)' }}
                    </div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25" @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import KnowledgebaseView from './View'
import Pagination from 'v-pagination-3'

export default {
    name: 'Knowledgebase',
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination,
        KnowledgebaseView,
    },
    mounted() {
        window.setTimeout(function () {
            this.$refs.searchbar.focus()
        }.bind(this), 100)

        this.setMetaTitle('List Knowledgebase Articles | JournoLink Control')
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('knowledgebase.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle the selection of an Article
         *
         * @param  {Object}
         * @return {void}
         */
        handleSelectedArticle(article) {
            this.$router.push({name: 'knowledgebase.show', params: {knowledgebaseId: article.kb_id}})
        },
        /**
         * Create a new Article
         *
         * @return {void}
         */
        createArticle() {
            this.$router.push({name: 'knowledgebase.create'})
        },
        /**
         * Navigate to manage Categories
         *
         * @return {void}
         */
        navigateToCategories() {
            this.$router.push({name: 'knowledgebase.categories.list'})
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'knowledgebase.list') {
            this.setMetaTitle('List Knowledgebase Articles | JournoLink Control')
            this.loadData()
        }

        if (to && to.params.newArticle) {
            window.setTimeout(() => {
                this.handleSelectedArticle(to.params.newArticle)
            }, 500)

            next()
        }

        next()
    },
}
</script>

<style lang="less">

</style>
